<template>
  <div class="finance-invoice">
    <div class="ly-card search-content">
      <div class="btn-group"></div>
      <div class="search-group">
        <el-input placeholder="班级名称" v-model.trim="searchFormData.keyword" @keydown.native.enter="search" />
        <el-select v-model="searchFormData.invoice_status" clearable @change="() => search()" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:reservation_number="row">
        <el-button type="text" class="reservation-number" size="small" @click="() => openInf(row)">{{
          row.reservation_number
        }}</el-button>
      </template>
      <template v-slot:action="row">
        <el-button type="primary" v-if="row.invoice_status === 2" size="mini" @click="changeStatus(row)">开票</el-button>
        <el-button type="danger" v-else size="mini" @click="changeStatus(row)">重开</el-button>
      </template>
    </ly-table>
    <pay-detail
      ref="payDetail"
      :sign_up_id="defData.signup_id"
      :def="defData"
      :class_id="defData.class_id"
      :contact_id="defData.contact_id"
      :keep_reserved="defData.keep_reserved"
      :buttons="buttons"
      @success="search"
    />
  </div>
</template>
<script>
import { Input, Select, Option } from 'element-ui';

import LyTable from '@/components/LyTable';
import { invoiceTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import PayDetail from '@/components/PayDetailOrder';


export default {
  name: 'EnteredStudent',
  components: {
    ElInput: Input,
    LyTable,
    ElSelect: Select,
    ElOption: Option,
    PayDetail
  },
  data() {
    return {
      searchFormData: {
        keyword: '',
        invoice_status: ''
      },
      tableHeader: invoiceTable,
      getTableData: finance.invoiceList,
      options: [],
      defData: {}
    };
  },
  mounted() {
    this.search();
    finance.invoiceStatus().then(res => {
      if (res && res.data) this.options = res.data;
    });
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    },
    changeStatus(row) {
      finance.controlInvoice({
        id: row.id
      }).then(res => {
        if (res) {
          this.$message.success(res.msg || '开票成功！');
          this.search();
        }
      });
    },
    openInf(row) {
      console.log('row---', row);
      this.defData = { ...row };
      this.$refs.payDetail.open();
    }
  }
};
</script>
<style lang="less">
.finance-invoice {
  .enter-form .el-input {
    width: 350px;
  }
  .use-reserved .el-checkbox__label {
    font-weight: 700;
  }
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
</style>
